import { http, mergePatchConfig, buildQuery } from "@/composables/api/http";

// Полный CRUD по проектам/темам/рубрикам/доступам. См. api_swagger/projects.json.
export const projectsApi = {
    list(params) {
        return http.get(`/projects${buildQuery(params)}`).then((r) => r.data);
    },
    get(projectId) {
        return http.get(`/projects/${projectId}`).then((r) => r.data);
    },
    create(body) {
        return http.post("/projects", body).then((r) => r.data);
    },
    update(projectId, body) {
        return http.put(`/projects/${projectId}`, body).then((r) => r.data);
    },
    patch(projectId, body) {
        return http
            .patch(`/projects/${projectId}`, JSON.stringify(body), mergePatchConfig)
            .then((r) => r.data);
    },
    remove(projectId) {
        return http.delete(`/projects/${projectId}`);
    },
    archive(projectId) {
        return http.post(`/projects/${projectId}/archive`);
    },
    unarchive(projectId) {
        return http.post(`/projects/${projectId}/unarchive`);
    },
    setActive(projectId) {
        return http.put(`/projects/${projectId}/active`);
    },
    clearActive() {
        return http.delete("/projects/active");
    },

    listShares(projectId) {
        return http.get(`/projects/${projectId}/shares`).then((r) => r.data);
    },
    share(projectId, items) {
        return http.post(`/projects/${projectId}/shares`, { items });
    },
    revokeShare(projectId, userId) {
        return http.delete(`/projects/${projectId}/shares/${userId}`);
    },

    listRubrics(projectId) {
        return http.get(`/projects/${projectId}/rubrics`).then((r) => r.data);
    },
    getRubric(projectId, rubricId) {
        return http.get(`/projects/${projectId}/rubrics/${rubricId}`).then((r) => r.data);
    },
    createRubric(projectId, body) {
        return http.post(`/projects/${projectId}/rubrics`, body).then((r) => r.data);
    },
    updateRubric(projectId, rubricId, body) {
        return http.put(`/projects/${projectId}/rubrics/${rubricId}`, body).then((r) => r.data);
    },
    patchRubric(projectId, rubricId, body) {
        return http
            .patch(`/projects/${projectId}/rubrics/${rubricId}`, JSON.stringify(body), mergePatchConfig)
            .then((r) => r.data);
    },
    removeRubric(projectId, rubricId) {
        return http.delete(`/projects/${projectId}/rubrics/${rubricId}`);
    },

    listThemes(projectId) {
        return http.get(`/projects/${projectId}/themes`).then((r) => r.data);
    },
    getTheme(projectId, themeId) {
        return http.get(`/projects/${projectId}/themes/${themeId}`).then((r) => r.data);
    },
    createTheme(projectId, body) {
        return http.post(`/projects/${projectId}/themes`, body).then((r) => r.data);
    },
    updateTheme(projectId, themeId, body) {
        return http.put(`/projects/${projectId}/themes/${themeId}`, body).then((r) => r.data);
    },
    patchTheme(projectId, themeId, body) {
        return http
            .patch(`/projects/${projectId}/themes/${themeId}`, JSON.stringify(body), mergePatchConfig)
            .then((r) => r.data);
    },
    removeTheme(projectId, themeId) {
        return http.delete(`/projects/${projectId}/themes/${themeId}`);
    },
    listThemeRubrics(projectId, themeId) {
        return http.get(`/projects/${projectId}/themes/${themeId}/rubrics`).then((r) => r.data);
    },
};
